import api from '../../tools/api-tools'
import resUrl from './resource-url'
import { mainWebPostData } from '../../config/net'

class ValueAddedService {
  /* =====================================2019-11-11活动使用=========================================================== */
  reveiveCoupon () {
    return api.post(resUrl.reveiveCoupon.url, mainWebPostData(resUrl.reveiveCoupon.method, {})).then(res => {
      let model = res.data.Model
      return model
    })
  }
  receiveStatus () {
    return api.post(resUrl.receiveStatus.url, mainWebPostData(resUrl.receiveStatus.method, {})).then(res => {
      let model = res.data.Model
      return model
    })
  }
}

export default ValueAddedService



// WEBPACK FOOTER //
// ./src/model/christmas/index.js